import { render, staticRenderFns } from "./InstagramCard.vue?vue&type=template&id=5a941904&"
import script from "./InstagramCard.vue?vue&type=script&lang=js&"
export * from "./InstagramCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports